// Fiche produit (/product/:id) : galerie, bloc d'achat, upsell, accessoires,
// souvenir et fiche technique.
// RÈGLE : les valeurs françaises sont le texte EXACT du site d'avant la
// traduction — on ne réécrit pas la copie en passant.
// Les textes PRODUIT (name, tagline, description, features) viennent de la
// base via l'API : ils passent par tp()/tpList(), jamais par ces clés.
export default {
  'fiche.seo.titre': '{nom} — Joyful Reveal',
  'fiche.seo.descriptionDefaut':
    'Le jeu de gender reveal Joyful Reveal : quiz en deux équipes, puzzle à assembler et pièce finale à gratter.',
  'fiche.seo.titreIntrouvable': 'Produit introuvable',
  'fiche.seo.titreErreur': 'Erreur de chargement',
  'fiche.seo.descriptionErreur': 'Ce produit n’est plus disponible sur la boutique Mirum Games.',

  'fiche.chargement.produit': 'Chargement du produit…',

  'fiche.erreur.introuvableTitre': 'Ce pack n’existe plus',
  'fiche.erreur.erreurTitre': 'Chargement impossible',
  'fiche.erreur.introuvableTexte':
    'Il a peut-être été remplacé. Retrouvez tous nos packs sur la boutique.',
  'fiche.erreur.erreurTexte': 'La connexion au serveur a échoué. Réessayez dans un instant.',
  'fiche.erreur.versBoutique': '🛍️ Voir la boutique',

  'fiche.ariane.label': 'Fil d’Ariane',

  'fiche.visuels.boiteAlt':
    'Face avant de la boîte Joyful Reveal : deux oursons et la pièce de puzzle à gratter',
  'fiche.visuels.boiteLegende': 'La boîte',
  'fiche.visuels.dosAlt':
    'Dos de la boîte : les 4 étapes du jeu, les langues des règles et le QR code',
  'fiche.visuels.dosLegende': 'Le dos de la boîte',
  'fiche.visuels.contenuAlt':
    'Contenu du Pack Premium : la boîte, le questionnaire et les deux pochons',
  'fiche.visuels.contenuLegende': 'Ce que vous recevez',
  'fiche.visuels.pochonsAlt': 'Les deux pochons en coton remis aux deux équipes',
  'fiche.visuels.pochonsLegende': 'Les pochons d’équipe',
  'fiche.visuels.grattageAlt': 'Une main gratte à la pièce de monnaie la case dorée du puzzle : le mot GIRL apparaît',
  'fiche.visuels.grattageLegende': 'Le grattage',
  'fiche.visuels.puzzleEncadreAlt':
    'Le puzzle assemblé dans un cadre doré, posé sur un piano entre deux bougeoirs',
  'fiche.visuels.puzzleEncadreLegende': 'Le souvenir encadré',
  'fiche.visuels.puzzleTableAlt':
    'Le puzzle assemblé dans son cadre doré, posé sur une table en chêne',
  'fiche.visuels.puzzleTableLegende': 'Après la fête',
  'fiche.visuels.questionnaireAlt':
    'Le questionnaire imprimé sur carton, avec ses colonnes Équipe 1, Équipe 2 et Parents',
  'fiche.visuels.questionnaireLegende': 'Le questionnaire imprimé',
  'fiche.visuels.voir': 'Voir : {legende}',

  'fiche.achat.gamme': 'Joyful Reveal — Ours',
  'fiche.achat.promesse':
    'Onze questions, deux équipes, une pièce à gratter — et tout le monde découvre en même temps.',
  'fiche.achat.remise': '−{n} %',
  'fiche.achat.contenuTitre': 'Ce que contient ce pack',
  'fiche.achat.ajouter': '🛒 Ajouter au panier',
  'fiche.achat.indisponible': 'Momentanément indisponible',
  'fiche.achat.reappro': 'Réapprovisionnement en cours',
  'fiche.achat.expedition': '📦 Expédié de Belgique sous 1 à 2 jours ouvrables',
  // Doit rester aligné sur PAYS_LIVRES (frontend/src/lib/zonesLivraison.js) :
  // cette phrase annonçait encore trois pays alors que le tunnel en propose six.
  'fiche.achat.livraison':
    '🚚 Livraison en Belgique, France, Luxembourg, Pays-Bas, Allemagne et Espagne — port calculé au paiement',
  'fiche.achat.langue':
    '🇫🇷 Boîte et règles en français (résumé bilingue français / anglais sur la boîte)',
  'fiche.achat.retour': '↩️ 14 jours pour changer d’avis',

  'fiche.genre.titre': 'C’est pour…',
  'fiche.genre.fille': 'Fille',
  'fiche.genre.garcon': 'Garçon',
  'fiche.genre.mixte': 'Fille + Garçon',
  'fiche.genre.alerte': 'Choisissez d’abord fille ou garçon.',
  'fiche.genre.discretion':
    'Personne d’autre que vous ne le saura : c’est la pièce à gratter qui l’annoncera.',
  'fiche.genre.packMixte': '👫 Ce pack contient la version fille ET la version garçon',
  'fiche.genre.packGarcon': '👦 Version garçon',
  'fiche.genre.packFille': '👧 Version fille',

  // Phrase en 4 segments car deux passages sont en gras dans le JSX :
  // « Pour [X de plus], le [NOM] ajoute les accessoires qui font toute la fête. »
  'fiche.upsell.badge': '⭐ Le plus choisi',
  'fiche.upsell.phraseAvant': 'Pour',
  'fiche.upsell.phraseGras': '{prix} de plus',
  'fiche.upsell.phraseMilieu': ', le',
  'fiche.upsell.phraseApres': 'ajoute les accessoires qui font toute la fête.',
  'fiche.upsell.voir': 'Voir le {nom} →',

  'fiche.caracteristiques.joueursLabel': 'Joueurs',
  'fiche.caracteristiques.joueursValeur': '2 à 10',
  'fiche.caracteristiques.dureeLabel': 'Durée',
  'fiche.caracteristiques.dureeValeur': '≈ 20 minutes',
  'fiche.caracteristiques.piecesLabel': 'Pièces',
  'fiche.caracteristiques.piecesValeur': '11 + 1 à gratter',
  'fiche.caracteristiques.ageLabel': 'Âge',
  'fiche.caracteristiques.ageValeur': 'Dès 3 ans',

  'fiche.etapes.reglesLien': 'Lire les règles complètes',
  'fiche.etapes.reglesSuite': '— les 11 questions sont fournies, prêtes à imprimer.',

  'fiche.accessoires.titreAvec': '🎁 Tout est déjà prêt dans ce pack',
  'fiche.accessoires.titreSans': '🎁 Envie que tout soit prêt en ouvrant la boîte ?',
  'fiche.accessoires.introAvec':
    'Vous ouvrez la boîte, vous posez le questionnaire sur la table, chacun prend son pochon — et la partie commence.',
  'fiche.accessoires.introSans':
    'Le Pack Premium ajoute les trois accessoires qui font la différence le jour J :',
  'fiche.accessoires.photoContenuAlt':
    "Le contenu du Pack Premium posé à plat : la boîte, le questionnaire imprimé et les deux pochons d'équipe",
  'fiche.accessoires.photoContenuLegende':
    'Le questionnaire imprimé, la boîte et les pochons — photo réelle',
  'fiche.accessoires.photoPochonsAlt':
    'Les deux pochons en coton à cordelette, étiquetés Équipe 1 et Équipe 2',
  'fiche.accessoires.photoPochonsLegende': "Les pochons d'équipe en coton — photo réelle",
  'fiche.accessoires.pochonsTitre': 'Deux pochons en coton',
  'fiche.accessoires.pochonsTexte':
    'Étiquetés Équipe 1 et Équipe 2 : chacun rejoint son camp en arrivant, la partie démarre toute seule.',
  'fiche.accessoires.questionnaireTitre': 'Le questionnaire, déjà imprimé',
  'fiche.accessoires.questionnaireTexte':
    'Les 11 questions sur carton 400 g, avec les colonnes de score des deux équipes — et un modèle vierge pour écrire les vôtres.',
  'fiche.accessoires.enveloppeTitre': "L'enveloppe souvenir",
  'fiche.accessoires.enveloppeTexte':
    'Après la fête, le questionnaire rempli s’y glisse — elle est pensée pour se fixer au dos d’un cadre.',
  'fiche.accessoires.decouvrir': 'Découvrir le {nom} →',

  'fiche.souvenir.photoAlt':
    'Le puzzle terminé, encadré et accroché au mur d’une chambre de bébé',
  'fiche.souvenir.photoLegende': "Le puzzle du jour J — 14 × 21 cm, le format d'un cadre",
  'fiche.souvenir.surtitre': 'Et après la fête ?',
  'fiche.souvenir.titre': 'Il reste un tableau',
  // Phrase coupée autour du « 14 × 21 cm » en gras (la mesure ne se traduit pas).
  'fiche.souvenir.tailleAvant': 'Le puzzle terminé fait',
  'fiche.souvenir.tailleApres':
    "— pile la taille d'un cadre du commerce. Beaucoup de parents l'encadrent et l'accrochent dans la chambre de bébé : le jour où tout le monde a appris la nouvelle, en une image.",
  // Phrase coupée autour de « l'enveloppe souvenir » en gras.
  'fiche.souvenir.premiumAvant':
    'Le questionnaire de ce pack est prévu pour ça : équipe gagnante, qui a gratté la pièce, la date — une fois rempli, glissez-le dans',
  'fiche.souvenir.premiumEnveloppe': "l'enveloppe souvenir",
  'fiche.souvenir.premiumApres': ', fixée au dos du cadre. Dans dix ans, rouvrez-la ensemble.',
  'fiche.souvenir.upsell':
    "Avec le Pack Premium, le questionnaire rempli le jour J (équipe gagnante, qui a gratté, la date) se glisse dans l'enveloppe souvenir, au dos du cadre. Dans dix ans, rouvrez-la ensemble.",

  'fiche.specs.titre': '📋 Fiche technique',
  'fiche.specs.contenuLabel': 'Contenu de la boîte',
  'fiche.specs.contenuValeur': '11 pièces de puzzle à gagner + 1 pièce unique à gratter',
  'fiche.specs.principeLabel': 'Principe',
  'fiche.specs.principeValeur':
    'Quiz en deux équipes, puzzle à assembler, révélation finale au grattage',
  'fiche.specs.reglesLabel': 'Règles',
  'fiche.specs.reglesValeur':
    'Résumées au dos de la boîte, version complète en ligne via le QR code',
  'fiche.specs.matiereLabel': 'Matière',
  'fiche.specs.matiereValeur': 'Carton — boîte et pièces',
  'fiche.specs.puzzleLabel': 'Puzzle assemblé',
  'fiche.specs.puzzleValeur': '14 × 21 cm — la taille d’un cadre du commerce',
  'fiche.specs.securiteLabel': 'Sécurité',
  'fiche.specs.securiteValeur':
    'Conforme CE / EN 71. Petites pièces : ne convient pas aux enfants de moins de 3 ans',
  'fiche.specs.origineLabel': 'Origine',
  'fiche.specs.origineValeur': 'Conçu et expédié depuis la Belgique par Mirum Games',
};
